import mifosRepository, {MifosRepository} from "./MifosRepository";

const resource = "/authentication";

export default {

  authenticate1(username, password) {
    const queryParam = `?username=${username}&password=${password}`;
    mifosRepository.setContentType("application/json");
    return MifosRepository.post(`${resource}${queryParam}`);
  },

  authenticate(credentialsParams) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.post(`${resource}`, credentialsParams);
  }
}
